import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("isLogin") === "true";
  const token = localStorage.getItem("token");

  let isTokenValid = false;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // seconds
      if (decoded.exp && decoded.exp > currentTime) {
        isTokenValid = true;
      }
    } catch (err) {
      // console.error("Invalid token:", err);
    }
  }

  if (!isLoggedIn || !token || !isTokenValid) {
    // clear everything and redirect
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;